// Utils
import createDeepEqualSelector from 'utils/reselect/createDeepEqualSelector';
import { calculateTotalPaidHours } from 'utils/timesheets';

// Selectors
import { makeSelectValuesTimesheetEntry } from 'services/timesheetTimesheetEntriesForm/selectors';

const selectInitialValues = createDeepEqualSelector(
    [makeSelectValuesTimesheetEntry()],
    valuesTimesheetEntryState => {
        if (!valuesTimesheetEntryState) return undefined;
        const { startTime, endTime } = valuesTimesheetEntryState;

        const totalHours = calculateTotalPaidHours({ startTime, endTime });

        return {
            startTime,
            endTime,
            autoCalculateHours: true,
            original: valuesTimesheetEntryState,
            duplicates: [
                {
                    ...valuesTimesheetEntryState,
                    hours: totalHours
                }
            ]
        };
    }
);

export { selectInitialValues };
